import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {HotelImagesGalleryComponent} from './hotel-images-gallery.component';
import {EvaButtonModule} from "../eva-button/eva-button.module";
import {ImagesGallerySliderModule} from '@shopping-angular-components/images-gallery-slider'
import {SliderModule} from "../slider/slider.module";
import {MainTitleModule} from "../main-title/main-title.module";

@NgModule({
  declarations: [HotelImagesGalleryComponent],
  imports: [CommonModule, EvaButtonModule, ImagesGallerySliderModule, SliderModule, MainTitleModule],
  exports: [HotelImagesGalleryComponent]
})
export class HotelImagesGalleryModule { }
